import React from 'react';
import { Mail } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
interface ContactEmailProps {
  user?: 'solutions' | 'michael.ryan';
  label?: string;
  className?: string;
  iconClassName?: string;
}
export function ContactEmail({
  user = 'solutions',
  label = 'Email CT Group',
  className,
  iconClassName
}: ContactEmailProps) {
  const openEmail = () => {
    window.location.href = `mailto:${user}@${['ctgroup', 'com', 'au'].join('.')}`;
  };
  return <button type="button" onClick={openEmail} className={twMerge('inline-flex min-h-[44px] items-center gap-2 rounded-lg font-semibold transition-colors focus-visible:outline-none', className)} aria-label={label} data-id="element-426" data-mp="1ahpob7eefyxo">
      <Mail className={twMerge('h-4 w-4', iconClassName)} aria-hidden data-id="element-427" data-mp="11f6pcydqi6gp" />
      {label}
    </button>;
}